import { IPublishDestination } from '../../types';
import { destinationId } from '../destinationId/destinationId';

/**
 * Narrows a channel selection to the channels still present in `publicationData`.
 *
 * Channels are derived from a refetchable venues query, so a selection held in form state can
 * outlive the channels it names. Anything gating on that selection has to work from this
 * intersection rather than the raw selection, or it counts channels that can no longer publish.
 */
export const getAvailableChannelIds = (
  publicationData: IPublishDestination[],
  selectedChannelIds: string[] = [],
): string[] => {
  const availableChannelIds = new Set(publicationData.map(destinationId));

  return selectedChannelIds.filter((channelId) => availableChannelIds.has(channelId));
};
